'use strict';

const Mixin = require('./mixin');
const baggageOptionsCollection = require('../collections/baggages_row_options').getInstance();

module.exports = new Mixin({
    updateBaggageSelection: function(options) {
        var newOptionCid = options.newOptionCid;
        var previousSelectedOption = baggageOptionsCollection.getCurrentSelectedOption(newOptionCid);
        var newSelectedOption = this.getBaggageOptionByCid(newOptionCid);

        baggageOptionsCollection.updateOption(newOptionCid, options.beforeUpdateHook, options.afterUpdateHook);

        if (options.triggerEvents) {
            this.triggerOnBaggageChange({
                currentOption: newSelectedOption,
                previousOption: previousSelectedOption,
                isUserAction: options.isUserAction,
                avoidNags: options.avoidNags,
            });
        }
    },
    selectDefaultOption: function(idPassenger, idRow, isUserAction) {
        var previousSelectedOption = baggageOptionsCollection.getRowSelection(idPassenger, idRow);
        var defaultOption = baggageOptionsCollection.getDefaultOption(idPassenger, idRow);

        baggageOptionsCollection.selectDefaultOption(idPassenger, idRow);

        this.triggerOnBaggageChange({
            currentOption: defaultOption,
            previousOption: previousSelectedOption,
            isUserAction: isUserAction,
        });
    },
    updateAllMatchingBaggagesOptions: function(searchPattern, excludedPassengerId, options) {
        var baggagesOptions = Odigeo._.filter(baggageOptionsCollection.getOptions(searchPattern), function(baggageOption) {
            return baggageOption.get('idPassenger') !== excludedPassengerId;
        });
        this.updateBaggagesOptions({
            baggagesOptions: baggagesOptions,
            triggerEvents: true,
            avoidNags: options.avoidNags,
        });
    },
    updateBaggagesOptions: function(options) {
        Odigeo._.each(options.baggagesOptions, function(baggageOption) {
            this.updateBaggageSelection({
                newOptionCid: baggageOption.cid,
                isUserAction: false,
                triggerEvents: options.triggerEvents,
                avoidNags: options.avoidNags,
            });
        }, this);
    },
    formatOption: function(option) {
        return Odigeo.AB.isResidentDiscount && Odigeo.AB.isResidentDiscountKeepAncillaries
            ? Odigeo._.pick(option.getAll(), ['pieces', 'kilos', 'idRow'])
            : Odigeo._.pick(option.getAll(), ['pieces', 'kilos', 'price', 'idRow']);
    },
    getActualSelection: function(pax) {
        return Odigeo._.chain(this.getAllBaggagesOptions({idPassenger: pax}))
            .filter(Odigeo._.method('get', 'selected'))
            .map(this.formatOption)
            .value();
    },
    getAvailableOptions: function(options, pax) {
        var optionsAvailable = this.getAllBaggagesOptions({idPassenger: pax});
        return Odigeo._.filter(optionsAvailable, Odigeo._.bind(function(option) {
            return Odigeo._.some(options, Odigeo._.partial(Odigeo._.isEqual, this.formatOption(option)));
        }, this));
    },
    triggerOnBaggageChange(options) {
        baggageOptionsCollection.updateShoppingCart(options?.currentOption);
        Odigeo.trigger('baggagesObserver:onBaggageChange', this.extendTriggerData(options));
    },
    extendTriggerData: function(data) {
        const currentOption = data.currentOption;
        const isBaggageBeingRemoved = currentOption.get('selected') &&
            currentOption.get('price') === 0 &&
            data.previousOption.get('price') !== 0;

        return Odigeo._.extend({}, data, {
            isBaggageBeingRemoved: isBaggageBeingRemoved,
            idPassenger: currentOption.get('idPassenger'),
        });
    },
    setDiscountFigure: function(discountFigure) {
        var value = discountFigure || this.options.discountFigure;
        if (Odigeo._.isNull(baggageOptionsCollection.discountFigure)) {
            baggageOptionsCollection.setDiscountFigure(value);
        }
    },
    getDiscountFigure() {
        return baggageOptionsCollection.getDiscountFigure();
    },
    getPrimeSavedAmount() {
        return baggageOptionsCollection.getPrimeSavedAmount();
    },
});
